import firebase from 'firebase/compat/app';
import { fetchUsers } from '../../../../services/usersServices';
import { startOfWeek, addWeeks, format } from 'date-fns';
import { getTime } from '../../../../services/projects-services';

export const fetchAllUsersWeeklyHoursMap = async (startDate, endDate) => {
  try {
    const allUsers = await fetchUsers();

    const usersObj = allUsers.reduce((acc, user) => {
      const userName = `${user.firstName}_${user.surname}`.replace(/\s+/g, '_').toLowerCase();

      acc[userName] = user;
      return acc;
    }, {});

    const data = await getTime();

    let currentWeekStart = startOfWeek(new Date(startDate), {
      weekStartsOn: 1,
    });
    const weeksObj = {};

    while (currentWeekStart <= new Date(endDate)) {
      const weekStartingKey = format(currentWeekStart, 'yyyy-MM-dd');
      weeksObj[weekStartingKey] = [];
      currentWeekStart = addWeeks(currentWeekStart, 1);
    }

    data?.forEach((d) => {
      const id = d.id;
      const weeklyHoursMap = d.weeklyHours || {};

      for (const weekKey in weeklyHoursMap) {
        if (weeksObj.hasOwnProperty(weekKey)) {
          const projects = weeklyHoursMap[weekKey];

          projects.map((clientEntry) => {
            const hours = clientEntry?.hours || [];

            if (!usersObj[id]?.email) {
              console.log('No user found for id:', usersObj[id], id);
            }
            const hoursList = hours.map((entry) => {
              return {
                userEmail: usersObj[id]?.email || '',
                flowId: clientEntry?.flowId || '',
                client: clientEntry?.clientName || '',
                projectGroupName: clientEntry?.projectGroupName || '',
                projectName: clientEntry?.projectName || '',
                deliverable: clientEntry?.deliverable || '',
                role: clientEntry?.role || '',
                rate: usersObj[id]?.rate || '',
                cost: usersObj[id]?.cost || '',
                timeEntryDate: entry.date,
                billableHours: entry.hours,
                nonBillableHours: entry.isNonBillable || '0.00',
                note: entry.note,
                state: entry.state || '',
              };
            });

            weeksObj[weekKey] = [...weeksObj[weekKey], ...hoursList];
          });
        }
      }
    });

    const returnData = Object.values(weeksObj)?.flat();

    return returnData;
  } catch (error) {
    console.error('Error fetching weekly hours:', error);
    return [];
  }
};

export const parseDate = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.split(/[-\/]/);

  if (parts.length === 3) {
    const [year, month, day] = parts[0].length === 4 ? parts : [parts[2], parts[1], parts[0]];
    return new Date(
      Date.UTC(
        parseInt(year, 10),
        parseInt(month, 10) - 1, // Month is 0-based
        parseInt(day, 10),
      ),
    );
  }

  // Fallback to assume UTC
  const parsedDate = new Date(dateStr);
  return new Date(
    Date.UTC(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate()),
  );
};

export const isDateInRange = (dateStr, startDateStr, endDateStr) => {
  const date = parseDate(dateStr);
  const startDate = parseDate(startDateStr);
  const endDate = parseDate(endDateStr);

  if (!date || !startDate || !endDate) return false;

  return date >= startDate && date <= endDate;
};
